/*
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Apache License, Version 2.0 (the "License").
You may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { Typography, Card, CardContent } from '@mui/material';
import React from 'react';
import { FactualStatementDto } from '@ink-ai/insight-service-sdk';
import CitationList from './CitationList';

interface FactFactualResultProps {
  factCheckFactualResult: FactualStatementDto;
  index: number;
  onClick: () => void;
}

const FactFactualResult: React.FC<FactFactualResultProps> = ({
  factCheckFactualResult,
  index,
  onClick,
}) => {
  return (
    <>
      <Card
        key={index}
        sx={{
          marginY: 2,
          borderRadius: 4,
        }}
        onClick={() => {
          onClick();
        }}
      >
        <CardContent sx={{ textAlign: 'left' }}>
          <Typography variant="body2" sx={{ mb: 1 }}>
            {factCheckFactualResult.originalSentence}
          </Typography>
          <CitationList citations={factCheckFactualResult.citations} />
        </CardContent>
      </Card>
    </>
  );
};

export default FactFactualResult;
